import { useState, useContext } from 'react'
import { Button, Drawer, Divider, Modal, Form, Input, message } from 'antd'
import { FaUserCircle } from "react-icons/fa"
import { useNavigate } from 'react-router-dom'
import { MyContext } from '../App'

export function UserMenu() {

      const navigate = useNavigate()

      const { AppData, UserData, setUserData } = useContext(MyContext)

      const [ open, setOpen ] = useState(false)
      const [ passwordModalOpen, setPasswordModalOpen ] = useState(false)
      const [ loading, setLoading ] = useState(false)
      const showDrawer = () => {
            setOpen(true)
      }
      const onClose = () => {
            setOpen(false)
      }

      function logout() {
            sessionStorage.removeItem("dasher_token")
            sessionStorage.removeItem("dasher_user")
            setUserData({ loggedIn: false })
            navigate('/')
      }

      const onChangePassword = async (values) => {

            setLoading(true)

            try {

                  const token = sessionStorage.getItem("dasher_token")

                  const response = await fetch(`${AppData.api.base}/auth/change-password`, {
                        method: "POST",
                        headers: {
                              "Content-Type": "application/json",
                              ...(token ? { Authorization: `Bearer ${token}` } : {})
                        },
                        body: JSON.stringify({
                              userId: UserData.id,
                              oldPassword: values.oldPassword,
                              newPassword: values.newPassword
                        })
                  })

                  const data = await response.json()

                  if (data.status === "success") {
                        message.success("Password updated")
                        setPasswordModalOpen(false)
                  } else {
                        message.error(data.result || "Unable to update password")
                  }

            } catch (err) {

                  console.log(err)
                  message.error("Something went wrong")

            }

            setLoading(false)
      }

      return (

            <>
                  <FaUserCircle className="clickable" onClick={showDrawer} style={{ marginLeft: '25px', color: 'rgba(0,0,0,0.6)', fontSize: '30px', marginTop: '10px' }} />

                  <Drawer title="PROFILE" placement="right" onClose={onClose} open={open}>

                        <p>Name: {UserData.first_name} {UserData.last_name}</p>
                        <p>Email: {UserData.username}</p>
                        <p>Management: {UserData.isManagement === 1 ? 'Yes' : 'No'}</p>

                        <Divider />

                        <p>App Version: {AppData.version}</p>

                        <Divider />

                        <div className="menu-link">
                              <Button type="link" onClick={() => setPasswordModalOpen(true)}>Change Password</Button>
                        </div>

                        <div className="menu-link">
                              <Button type="link" onClick={logout}>Logout</Button>
                        </div>

                  </Drawer>

                  <Modal
                        title="Change Password"
                        open={passwordModalOpen}
                        onCancel={() => setPasswordModalOpen(false)}
                        footer={null}
                  >
                        <Form
                              layout="vertical"
                              onFinish={onChangePassword}
                        >
                              <Form.Item
                                    label="Current Password"
                                    name="oldPassword"
                                    rules={[ { required: true, message: 'Please enter your current password' } ]}
                              >
                                    <Input.Password />
                              </Form.Item>
                              <Form.Item
                                    label="New Password"
                                    name="newPassword"
                                    rules={[ { required: true, message: 'Please enter a new password' } ]}
                              >
                                    <Input.Password />
                              </Form.Item>
                              <Form.Item>
                                    <Button type="primary" htmlType="submit" loading={loading}>
                                          Update Password
                                    </Button>
                              </Form.Item>
                        </Form>
                  </Modal>
            </>

      )

}